import { Component, computed, inject } from '@angular/core';
import { USER_ERROR_COPY } from '../i18n/user-facing-error.i18n';
import { DeskLangService } from '../services/desk-lang.service';
import { AppUnavailableService } from './app-unavailable.service';

@Component({
  selector: 'app-service-unavailable-page',
  standalone: true,
  template: `
    <div class="unavailable-page" role="alert">
      <div class="unavailable-card">
        <p class="brand">Jansunwai</p>
        <img
          class="logo"
          src="/deoria-government-logo.jpg"
          alt="Government of Uttar Pradesh"
        />
        <h1>{{ copy().serviceUnavailableTitle }}</h1>
        <p class="lede">{{ copy().serviceUnavailableBody }}</p>
        <button
          type="button"
          class="retry-btn"
          [disabled]="unavailable.retryInProgress()"
          (click)="onRetry()"
        >
          {{ copy().retry }}
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      .unavailable-page {
        min-height: 100vh;
        min-height: 100dvh;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1.5rem;
        background: var(--surface, #f4f6f8);
        color: var(--ink, #1a1a1a);
        box-sizing: border-box;
      }

      .unavailable-card {
        width: min(100%, 26rem);
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.85rem;
      }

      .brand {
        margin: 0;
        font-size: 1.05rem;
        font-weight: 700;
        letter-spacing: 0.02em;
        color: var(--brand-deep, #0b3d5c);
      }

      .logo {
        width: 4.5rem;
        height: 4.5rem;
        object-fit: contain;
        border-radius: 0.35rem;
      }

      h1 {
        margin: 0.25rem 0 0;
        font-size: clamp(1.35rem, 4vw, 1.65rem);
        font-weight: 700;
        line-height: 1.25;
        color: var(--ink, #1a1a1a);
      }

      .lede {
        margin: 0;
        font-size: 0.98rem;
        line-height: 1.55;
        color: var(--muted, #5a6570);
        max-width: 22rem;
      }

      .retry-btn {
        margin-top: 0.5rem;
        padding: 0.55rem 1.35rem;
        border: none;
        border-radius: 0.45rem;
        background: var(--brand-deep, #0b3d5c);
        color: var(--login-accent-contrast, #fff);
        font-size: 0.95rem;
        font-weight: 600;
        cursor: pointer;
      }

      .retry-btn:disabled {
        opacity: 0.65;
        cursor: not-allowed;
      }

      :host-context(html[data-theme='dark']) .unavailable-page {
        background: var(--surface, #0f1419);
        color: var(--ink, #e8eaed);
      }

      :host-context(html[data-theme='dark']) .brand {
        color: var(--brand-deep, #7eb8d9);
      }

      :host-context(html[data-theme='dark']) .retry-btn {
        background: var(--brand-deep, #7eb8d9);
        color: #0f1419;
      }
    `,
  ],
})
export class ServiceUnavailablePageComponent {
  readonly unavailable = inject(AppUnavailableService);
  private readonly deskLang = inject(DeskLangService);

  readonly copy = computed(() => USER_ERROR_COPY[this.deskLang.lang()]);

  onRetry(): void {
    void this.unavailable.retry();
  }
}
